import React, { useCallback, useMemo } from 'react';
import { VortexActions, VortexCanvas, VortexContainer } from '@rendering/vortex-react';
import { buildInstructionsUrl } from '@rendering/product-preview';
import { VortexError } from '../../errors/VortexError';
import { useVortexIntializationOptions } from '../../hooks/useVortexInitializationOptions';
const FALLBACK = null;
export function VortexPreview(_ref) {
  let {
    user,
    view,
    cimDocUrl,
    renderOptions,
    children,
    onError = console.error,
    onPaint
  } = _ref;
  const renderingInstructionsUrl = useMemo(() => buildInstructionsUrl({
    cimDocUrl
  }), [cimDocUrl]);
  const Canvas = useCallback(props => React.createElement(VortexCanvas, Object.assign({
    style: {
      width: '100%'
    }
  }, props)), []);
  const onAfterUpdate = useCallback(error => {
    if (!error) {
      onPaint === null || onPaint === void 0 ? void 0 : onPaint();
    }
  }, [onPaint]);
  const onInnerError = useCallback(error => {
    onError === null || onError === void 0 ? void 0 : onError(new VortexError(error));
  }, [onError]);
  const initializationOptions = useVortexIntializationOptions({
    view
  });
  return React.createElement(VortexContainer, {
    productConfig: view.vortex.model.content || view.vortex.model.url,
    user: user,
    renderingInstructionsUrl: renderingInstructionsUrl,
    cameraOptions: view.vortex.stage.content.cameraSettings,
    environmentOptions: view.vortex.stage.content.environmentSettings,
    fallback: FALLBACK,
    onError: onInnerError,
    onAfterUpdate: onAfterUpdate,
    initializationOptions: initializationOptions
  }, vortexState => {
    if (!children) {
      return React.createElement(Canvas, null);
    }
    return children({
      Canvas,
      renderActions: render => {
        var _a, _b;
        return React.createElement(VortexActions, {
          cameraViews: (_a = renderOptions === null || renderOptions === void 0 ? void 0 : renderOptions.cameraViews) !== null && _a !== void 0 ? _a : false,
          animations: (_b = renderOptions === null || renderOptions === void 0 ? void 0 : renderOptions.animations) !== null && _b !== void 0 ? _b : false
        }, actionParams => render(actionParams));
      },
      status: {
        loading: vortexState.loadingModel || vortexState.updatingCanvas,
        error: vortexState.error
      },
      vortexContext: vortexState
    });
  });
}
export default VortexPreview;